import React from "react";
import {Check} from "@sparkware/app-utils";
import {CyClass} from "../../../../../../common/cy-classes";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {ILiveTableInfo} from "../../../../../services/live-table-feeds-service/live-table-feeds.service.interface";
import {LiveCasinoGridItemInfoItemBox} from "../boxes/infobar/info-item/live-casino-grid-item-info-item.box";
import {LiveCasinoGridItemInfobarIconBox} from "../boxes/infobar/infobar-icon/live-casino-grid-item-infobar-icon.box";

export interface ITableSeatsComponentProps {
    tableInfo: ILiveTableInfo;
    isLiveStreamOverlay?: boolean;
}

export class TableSeatsComponent extends OrbitComponent<ITableSeatsComponentProps> {

    private _isTableFull() {

        if (this.props.tableInfo.Seats) {
            if (this.props.tableInfo.SeatsTaken?.length > 0) {
                return this.props.tableInfo.SeatsTaken.length === this.props.tableInfo.Seats;
            } else {
                return this.props.tableInfo.Players === this.props.tableInfo.Seats;
            }
        }

        return false;
    }

    private _getTableIsFullText() {
        return this._isTableFull() ? this.services.translation.translate(this._getTableIsFullTranslationKey()) : this._getPlayersCountFormated();
    }

    private _getTableIsFullTranslationKey() {
        return this.services.device.isMobile ? "LIVE_CASINO_TABLE_FULL_MOBILE" : "LIVE_CASINO_TABLE_FULL_PC";
    }

    private _getSeatsIconSource() {
        return this._isTableFull()
            ? this.services.theme.currentTheme.assets.images.live_arena.seat_icon_dark_png.toString()
            : this.services.theme.currentTheme.assets.images.live_arena.seat_icon_png.toString();
    }

    private _getPlayersCountFormated() {

        if (this.props.tableInfo.Seats) {
            if (this.props.tableInfo.SeatsTaken?.length > 0) {
                return `${this.props.tableInfo.SeatsTaken.length}/${this.props.tableInfo.Seats}`;
            } else {
                return `${this.props.tableInfo.Players}/${this.props.tableInfo.Seats}`;
            }
        }

        return this.props.tableInfo.Players;
    }

    render() {

        if (Check.isEmpty(this.props.tableInfo) || this.props.tableInfo.Players === undefined) {
            return null;
        }

        return (
            <LiveCasinoGridItemInfoItemBox isLiveStreamOverlay={this.props.isLiveStreamOverlay}
                                           className={"cy-live-casino-grid-item-infobar-game-seats-count"}>
                <LiveCasinoGridItemInfobarIconBox alt={`Seats_${this._getTableIsFullText()}`} src={this._getSeatsIconSource()}/>
                <span className={CyClass("cy-live-casino-grid-item-infobar-game-seats-count-text")}>{this._getTableIsFullText()}</span>
            </LiveCasinoGridItemInfoItemBox>
        );
    }
}
